"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterDateCell = void 0;
const local_date_field_1 = require("../../../components/local-date-field/local-date-field");
const filter_interval_cell_factory_1 = require("./filter-interval-cell-factory");
/**
 * @deprecated
 *
 * Use FilterLocalDateCell instead.
 */
exports.FilterDateCell = (0, filter_interval_cell_factory_1.filterIntervalCellFactory)(local_date_field_1.LocalDateField);
//# sourceMappingURL=filter-date-cell.js.map